import Qq from "@/assets/icons/profile/qq";
import { IconWrapper } from "@/pages/profile/components/atom";

export function BindQqIcon() {
  return (
    <IconWrapper>
      <Qq />
    </IconWrapper>
  );
}
